import React, { useState } from 'react';
import {
    Button,
    DialogActions,
    DialogContent,
    FormControl,
} from '@mui/material';
import { isNullOrUndefined } from '../../../utils/utils';
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import TextFieldStyled from '../../shared/TextFieldStyled';
import PrimaryBtn from '../../shared/Buttons/PrimaryButton';
import useQuotations from '../../../hooks/quotations/useQuotations';
import SnackbarUtils from '../../../utils/SnackbarUtils';
import useQuotationActionsDialog from '../../../hooks/dialogs/useQuotationActionsDialog';

const schema = yup.object().shape({
    title: yup.string().required('REQUIRED'),
});

const CreateOrderTemplate: React.FC<any> = (props) => {
    if (isNullOrUndefined(props)) {
        return null;
    }

    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATION_DIALOG.ORDER_TEMPLATE_DIALOG',
    });
    const { products, handleSave } = props;
    const quotations = useQuotations();
    const [isLoading, setIsLoading] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm<FormValues>({
        resolver: yupResolver(schema),
    });
    const quotationActionsDialog = useQuotationActionsDialog();

    const closeConfirmDialog = () => {
        reset();
        quotationActionsDialog.closeDialog();
    };

    const handleCreatedSuccessfully = (quotationId) => {
        reset();
        SnackbarUtils.success(t('SAVED_SUCCESSFULLY').toString());
        handleSave(quotationId);
    };

    const onConfirmDialog: SubmitHandler<FormValues> = (data) => {
        setIsLoading(true);
        quotations
            .saveCart({
                products: products,
                title: data.title,
            })
            .then(() => {
                handleCreatedSuccessfully(122232222);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <form onSubmit={handleSubmit(onConfirmDialog)}>
                <DialogContent>
                    <FormControl fullWidth>
                        <TextFieldStyled
                            label={t('NAME_LABEL').toString()}
                            error={!!errors.title}
                            {...register('title')}
                            helperText={
                                errors.title
                                    ? t(errors.title.message).toString()
                                    : ' '
                            }
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button size="small" onClick={closeConfirmDialog}>
                        {t('CANCEL')}
                    </Button>
                    <PrimaryBtn size="small" type="submit" disabled={isLoading}>
                        {t('CONFIRM')}
                    </PrimaryBtn>
                </DialogActions>
            </form>
        </>
    );
};

export default CreateOrderTemplate;

type FormValues = {
    title: string;
};
